export default __webpack_public_path__ + "static/media/icon_ui_gear.e591f3ad.png";